import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ApiService } from '@core/providers/http/api.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AnoLectivoService {
  private readonly path = 'bolsa';
  public params = new HttpParams();

  constructor(private apiService: ApiService) {}

  // List all AnoLectivo
  list(params?: any): Observable<any[]> {
    return this.apiService
      .get<{ data: any[] }>(
        `${this.path}/getAllAnoLectivo`,
        params
          ? new HttpParams({
              fromObject: params,
            })
          : this.params
      )
      .pipe(map((response) => response.data));
  }

  // Create new AnoLectivo
  public store(form: any): Observable<any> {
    const anoLectivo = form;
    return this.apiService
      .post<{ object: any }>(`${this.path}/AddAnoLectivo`, anoLectivo)
      .pipe(map((response) => response.object));
  }

  // Update existing AnoLectivo
  public update(form: FormGroup, id: string): Observable<any> {
    const anoLectivo = form.value;
    return this.apiService
      .put<{ object: any }>(`${this.path}/UpdateAnoLectivo/${id}`, anoLectivo)
      .pipe(map((response) => response.object));
  }

  // Delete existing AnoLectivo
  delete(id: string): Observable<any> {
    return this.apiService.delete(`${this.path}/DeleteAnoLectivoById/${id}`);
  }

  // Get AnoLectivo by ID
  public show(id: string): Observable<any> {
    return this.apiService
      .get<{ object: any }>(`${this.path}/getAnoLectivoById/${id}`)
      .pipe(map((response) => response.object));
  }
}
